import { Dictionary, FormField, FormValue } from "@/types";

export function mergeProps(
  defaultProps: Dictionary<any>,
  props: Dictionary<any>
): Dictionary<any> {
  Object.assign(defaultProps, props);
  return defaultProps;
}

export function getFieldProps(formField: FormField, formValue: FormValue) {
  return Object.keys(formField).reduce(
    (out, key) => {
      if (["type", "value", "name"].indexOf(key) > -1) return out;

      if (key === "title") {
        out["label"] = formField[key];
      } else if (key === "list") {
        out["items"] = formField[key];
      } else if (key === "clearable") {
        out[key] = formField[key] !== undefined ? formField[key] : true;
      } else out[key] = formField[key];

      return out;
    }, { value: formValue } as Dictionary<any>
  );
}
